/// <amd-module name="Widgets/CumulativeFlowDiagram/PlaceholderBoardUnsupportedError" />
import { Board } from "Analytics/Boards/CumulativeFlowDiagramQueries/LowestLevelVisibleBoardQuery";
import { IProjectData } from "Tfs/Platform/Page";
import { IDashboardsTeamData } from "Tfs/Widget/Context";
import { format } from "VSS/Core/Util/String";
import * as Resources from "Widgets/CumulativeFlowDiagram/Resources";

export class PlaceholderBoardUnsupportedError extends Error {
    // @ts-ignore - Silencing "TS6133: Build: '__proto__' is declared but its value is never read."
    private __proto__: Error;

    public project: IProjectData;
    public team: IDashboardsTeamData;
    public board: Board;

    public constructor(project: IProjectData, team: IDashboardsTeamData, board: Board) {
        const trueProto = new.target.prototype;

        super(format(Resources.Error_PlaceholderBoardUnsupported_Format, board.BoardName));

        this.project = project;
        this.team = team;
        this.board = board;

        /**
         * Used to support instanceof with custom errors.
         * TypeScript prototypes don't transpile correctly for certain built-in types like Error and Array.
         * However by explicitly setting the prototype the functionality is restored.
         * Subtypes of this custom error must also use this same workaround.
         * Can't use Object.setPrototypeOf because our headless browser used for unit tests doesn't support it.
         * https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
         */
        this.__proto__ = trueProto;
    }
}
